import { CLASSE_BADGE_ETAT, LIBELLE_ETAT } from './format';
import type { StatutMessage } from '../../types';

/** L'état d'un message en clair : À envoyer · Envoi en cours · Envoyé · Pas parti · Plus utile. */
export function EtatMessage({ statut, libelle }: { statut: StatutMessage; libelle?: string }) {
  return <span className={CLASSE_BADGE_ETAT[statut]}>{libelle ?? LIBELLE_ETAT[statut]}</span>;
}
